// Lightweight Google Analytics v4 initialization gated by consent
// Requires VITE_GA_MEASUREMENT_ID in env (e.g., G-XXXXXXXXXX)

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

export type CookieConsent = {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
};

const STORAGE_KEY = "cookie-consent-preferences";

function getConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function loadGaScript(measurementId: string) {
  if (document.getElementById("ga-script")) return; // already loaded
  const s = document.createElement("script");
  s.id = "ga-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(){ window.dataLayer?.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { anonymize_ip: true, send_page_view: true });
}

export function initAnalyticsIfConsented() {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;
  if (!measurementId) return; // not configured
  const consent = getConsent();
  if (consent?.analytics) {
    loadGaScript(measurementId);
  }
}

export function handleConsentUpdated(consent: CookieConsent) {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;
  if (!measurementId) return;
  if (consent.analytics) {
    loadGaScript(measurementId);
  }
}


